import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import {
  AccountListItemView,
  amountToneClass,
  meterToneClass,
  statusDotClass,
  statusTextClass,
} from "./account-list-item.utils";

/**
 * What goes inside an account's card in the Accounts list: logo, name with its source tag, the
 * balance, and (unless the list is in its "simple" form) the share meter and the status line. The
 * clickable wrapper (role, keyboard, selection) belongs to the page, which also owns the selected
 * styling, so this only draws the contents.
 */
@Component({
  selector: "app-account-list-item",
  templateUrl: "./account-list-item.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: "tw-flex tw-w-full tw-min-w-0 tw-flex-col tw-gap-2.5" },
})
export class AccountListItemComponent {
  readonly card = input.required<AccountListItemView>();
  /** One line per account: no meter and no status line; the status shows as a dot by the balance. */
  readonly simple = input(false);

  protected readonly amountClass = computed(() => amountToneClass(this.card().amountTone));

  protected readonly unitClass = computed(() =>
    this.card().isLiability ? "tw-text-color-status-error-text" : "tw-text-color-text-secondary",
  );

  protected readonly meterClass = computed(() => meterToneClass(this.card().meter.tone));

  protected readonly dotClass = computed(() => statusDotClass(this.card().status.level));

  protected readonly statusTextClass = computed(() => statusTextClass(this.card().status.level));
}
